import React from "react";
import "../styles/Terms.css";
import { useTranslation } from 'react-i18next';

export default function Terms() {
  const { t } = useTranslation();

  return (
    <div className="terms">
      <h1>{t('terms.title')}</h1>
      <p><strong>{t('terms.lastUpdate')} :</strong> {t('terms.date')}</p>

      <h2>{t('terms.section1Title')}</h2>
      <p>{t('terms.section1Text1')}</p>
      <p>{t('terms.section1Text2')}</p>

      <h2>{t('terms.section2Title')}</h2>
      <p>{t('terms.section2Text1')}</p>
      <p>{t('terms.section2Text2')}</p>

      <h2>{t('terms.section3Title')}</h2>
      <p>{t('terms.section3Text1')}</p>
      <p>{t('terms.section3Text2')}</p>

      <h2>{t('terms.section4Title')}</h2>
      <p>{t('terms.section4Text1')}</p>

      <h2>{t('terms.section5Title')}</h2>
      <p>{t('terms.section5Text1')}</p>
      <p>{t('terms.section5Text2')}</p>

      <h2>{t('terms.section6Title')}</h2>
      <p>{t('terms.section6Text1')}</p>

      <h2>{t('terms.section7Title')}</h2>
      <p>
        {t('terms.section7Text1')}<br />
        📧 <a href="mailto:contact@zeldle.xyz">contact@zeldle.xyz</a>
      </p>

      <p className="about-disclaimer">{t('terms.disclaimer')}</p>
    </div>
  );
}